import React from 'react';
import { useAppSelector } from '../../../../../../app/hooks';
import { originalBotTypeSelector, updateBotRequestSelector } from '../../../botUpdateSlice';
import styles from '../BotForm.module.css';

export const BotTypeChangeWarning: React.FC = () => {
    const originalBotType = useAppSelector(originalBotTypeSelector);
    const currentRequest = useAppSelector(updateBotRequestSelector);
    
    // Show warning if bot type has changed from original
    const showWarning = originalBotType && 
                       currentRequest.botType && 
                       originalBotType !== currentRequest.botType;
    
    if (!showWarning) {
        return null;
    }
    
    return (
        <div className={styles.botTypeChangeNote}>
            <img
                className={styles.botTypeChangeNoteIcon}
                src="/alertIcon.svg"
                alt="Warning"
            />
            <div>
                <strong>Assistant type changed:</strong> Changing the assistant type may require additional configuration in Tool Settings. 
                Please review and update your tool settings after saving to ensure all features work correctly.
            </div>
        </div>
    );
};